(() => {
  const CART_TARGET_SELECTOR = '#cart-icon-bubble';
  const PENDING_TIMEOUT = 10000;
  let pendingAdd = null;

  const getVisibleCartTarget = () => {
    const target = document.querySelector(CART_TARGET_SELECTOR);
    if (!target) return null;

    const rect = target.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return null;

    return { target, rect };
  };

  const animateCartTarget = (target) => {
    if (!target?.animate) return;

    target.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.16)', offset: 0.45 },
        { transform: 'scale(1)' },
      ],
      { duration: 260, easing: 'ease-out' }
    );
  };

  const animateBallToCart = (button) => {
    if (!button || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve();

    const startRect = button.getBoundingClientRect();
    if (startRect.width === 0 || startRect.height === 0) return Promise.resolve();

    const cartTarget = getVisibleCartTarget();
    const startX = startRect.left + startRect.width / 2;
    const startY = startRect.top + startRect.height / 2;
    const endX = cartTarget ? cartTarget.rect.left + cartTarget.rect.width / 2 : window.innerWidth - 28;
    const endY = cartTarget ? cartTarget.rect.top + cartTarget.rect.height / 2 : 28;
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const arcY = deltaY * 0.46 - Math.min(130, Math.abs(deltaX) * 0.12 + 58);

    const ball = document.createElement('span');
    ball.className = 'cart-fly-ball';
    ball.setAttribute('aria-hidden', 'true');
    ball.style.left = `${startX - 9}px`;
    ball.style.top = `${startY - 9}px`;
    document.body.appendChild(ball);

    const animation = ball.animate(
      [
        { transform: 'translate3d(0, 0, 0) scale(0.75)', opacity: 0 },
        { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1, offset: 0.12 },
        {
          transform: `translate3d(${deltaX * 0.48}px, ${arcY}px, 0) scale(0.82)`,
          opacity: 1,
          offset: 0.55,
        },
        { transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.18)`, opacity: 0 },
      ],
      { duration: 720, easing: 'cubic-bezier(0.35, 0.1, 0.2, 1)', fill: 'forwards' }
    );

    return new Promise((resolve) => {
      animation.addEventListener(
        'finish',
        () => {
          ball.remove();
          animateCartTarget(cartTarget?.target);
          resolve();
        },
        { once: true }
      );

      animation.addEventListener(
        'cancel',
        () => {
          ball.remove();
          resolve();
        },
        { once: true }
      );
    });
  };

  const loadCartRecommendations = async (drawer) => {
    const container = drawer?.querySelector('[data-cart-recommendations]');
    const productId = container?.dataset.productId;
    const productsSlot = container?.querySelector('[data-cart-recommendations-products]');
    if (!container || !productId || !productsSlot || container.dataset.loadedFor === productId) return;

    container.dataset.loadedFor = productId;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(
        `${root}recommendations/products?section_id=cart-drawer-recommendations&product_id=${encodeURIComponent(productId)}&limit=2&intent=related`
      );
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const results = documentFragment.querySelector('[data-cart-recommendation-results]');
      if (!results) return;

      const seenProductIds = new Set([String(productId)]);
      const selectedCards = [];
      results.querySelectorAll('[data-cart-recommendation-product]').forEach((card) => {
        const recommendationProductId = card.dataset.productId;
        if (!recommendationProductId || seenProductIds.has(recommendationProductId) || selectedCards.length >= 2) return;

        seenProductIds.add(recommendationProductId);
        selectedCards.push(card.cloneNode(true));
      });
      if (!selectedCards.length) return;

      productsSlot.replaceChildren(...selectedCards);
      container.hidden = false;
    } catch (error) {
      console.warn('Cart recommendations could not be loaded.', error);
    }
  };

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawerElement = customElements.get('cart-drawer');
    if (!CartDrawerElement || CartDrawerElement.prototype.cartFlyOpenPatched) return;

    const originalOpen = CartDrawerElement.prototype.open;
    CartDrawerElement.prototype.open = function (...args) {
      const result = originalOpen.apply(this, args);
      window.setTimeout(() => loadCartRecommendations(this), 80);
      return result;
    };
    CartDrawerElement.prototype.cartFlyOpenPatched = true;
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      const productForm = form instanceof Element ? form.closest('product-form') : null;
      if (!productForm) return;

      const button = productForm.querySelector('[type="submit"][name="add"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      pendingAdd = { button, startedAt: performance.now() };
    },
    true
  );

  const subscribeToCartUpdates = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') {
        window.setTimeout(() => loadCartRecommendations(document.querySelector('cart-drawer')), 120);
        return;
      }

      if (!pendingAdd) return;

      const currentAdd = pendingAdd;
      pendingAdd = null;
      if (performance.now() - currentAdd.startedAt > PENDING_TIMEOUT) return;

      return animateBallToCart(currentAdd.button);
    });

    return true;
  };

  if (!subscribeToCartUpdates()) {
    document.addEventListener('DOMContentLoaded', subscribeToCartUpdates, { once: true });
  }
})();

